import React from 'react';
import { FileText } from 'lucide-react';

const specsData = [
  { name: 'Мощность трансформатора', value: 'от 25 до 4000 кВА' },
  { name: 'Класс напряжения (ВН/НН)', value: '6/0,4 кВ или 10/0,4 кВ' },
  { name: 'Тип трансформатора', value: 'ТСЛ, ТСЗ, ТМГ, ТМ' },
  { name: 'Климатическое исполнение', value: 'УХЛ1 (от -60°C до +40°C)' },
  { name: 'Габариты и компоновка', value: 'Под проект или типовой чертёж' },
  { name: 'Защита и автоматика', value: 'По ТЗ или типовая схема' },
];

const KtpnSpecs: React.FC = () => {
  return (
    <section className="py-12 md:py-16">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold">
            Технические характеристики КТПН
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Основные параметры наших комплектных трансформаторных подстанций.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <table className="min-w-full">
              <tbody>
                {specsData.map((spec, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4 text-sm font-medium text-gray-900 md:text-base">{spec.name}</td>
                    <td className="px-6 py-4 text-sm text-gray-700 md:text-base">{spec.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <div className="mt-8 text-center bg-primary-50 p-6 rounded-lg border-l-4 border-primary-500">
            <div className="flex items-center justify-center">
                <FileText className="w-8 h-8 text-primary-600 mr-4" />
                <p className="text-lg font-semibold text-primary-800">
                  Вложите ТЗ или КП конкурентов — мы предложим лучше.
                </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KtpnSpecs; 